import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "358",
  "slug": "spot-nepal-from-satellite-imagery",
  "title": "How to Recognise Nepal in Satellite Images",
  "excerpt": "Nepal lies along the southern Himalaya.",
  "date": "2026-06-05",
  "category": "Geography",
  "image": "/blog-images/nepal.jpg",
  "readTime": "1 min",
  "author": "EarthGuessr Team",
  "content": [
    {
      "type": "paragraph",
      "text": "Nepal lies along the southern Himalaya. A wide view can show the transition from the low Terai through dissected hills to high mountain terrain. Rivers cut across these zones, providing routes to trace rather than three neat bands with fixed edges."
    },
    {
      "type": "heading",
      "text": "Checking the location"
    },
    {
      "type": "paragraph",
      "text": "Follow the Gandaki or Koshi system toward the plains and compare the mountain front with a labelled map. Similar elevation changes occur in northern India and Bhutan. Snow, terraced slopes, and a dry valley do not establish Nepal by themselves; the shape and position of a river basin provide additional evidence."
    }
  ],
  "imageAlt": "Nepal regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
